@if (task) {
  <div style="max-width: 350px; font-size: 11px;">
    <table cellspacing="20">
      <tr>
        <td colspan="100">
          @if (stateMeta) {
            <span
              ><i
              [class]="'circle-dark-gray ' + stateMeta.symbol"
              [ngStyle]="{ color: stateMeta.color }"
            ></i>
            -
          </span>
        }
        <b
          >{{ task?.taskNoDisplay }} - {{ task?.label
          }}@if (stateMeta) {
          <span> ({{ stateMeta.displayLabel }})</span>
          }</b
          >
        </td>
      </tr>
      @if (task?.category) {
        <tr>
          <td i18n="@@TaskCard_Tooltip_Category">Category:</td>
          <td>{{ task.category.label }}</td>
        </tr>
      }
      @if (task?.anlageNrIntern) {
        <tr>
          <td i18n="@@TaskCard_Tooltip_AnlageNr">Facility-No.:</td>
          <td>{{ GetAnlageNr(task) }}</td>
        </tr>
      }
      @if (GetShouldDisplayTaskLocation(task)) {
        <tr>
          <td i18n="@@TaskCard_Tooltip_TaskLocation">Location:</td>
          <td>{{ GetTaskLocationString(task) }}</td>
        </tr>
      }
      <tr>
        <td i18n="@@TaskCard_ToolTip_DateRangesActive">Dateranges active:</td>
        <td>
          <span>{{ task?.dateRangesActive | yesNo }}</span>
        </td>
      </tr>
      @if (task?.dateRanges) {
        <tr>
          @if (task?.dateRangesActive) {
            <td
              i18n="@@TaskCard_ToolTip_DateRanges_LabelWhenActive"
              >
        Planned for:
      </td>
          }
          @if (!task?.dateRangesActive) {
            <td
              i18n="@@TaskCard_ToolTip_DateRanges_LabelWhenInactive"
              >
        Last planned for:
      </td>
          }
          <td> @if (task?.dateRanges?.todoTime) {
            <span>
              {{
              task?.dateRanges?.todoTime?.toLocaleTimeString(undefined, {
              minute: "2-digit",
              hour: "2-digit"
              })
              }}
            </span>
          }
          @if (task?.dateRanges?.todoDate) {
            <span>
              @if (task?.dateRanges?.todoTime) {
                <span> - </span>
              }
              {{
              task?.dateRanges?.todoDate?.toLocaleDateString(undefined, {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
              })
              }}
            </span>
          }
          @if (task?.dateRanges?.plannedWeek) {
            <span>
              @if (task?.dateRanges?.todoDate) {
                <span> - </span>
              }
              {{ task?.dateRanges?.plannedWeek }}
            </span>
          }
          @if (task?.dateRanges?.periodOfAction) {
            <span>
              @if (task?.dateRanges?.todoDate || task?.dateRanges?.plannedWeek) {
                <span
                  >
                  -
                </span>
              }
              {{ task?.dateRanges?.periodOfAction }}
            </span>
          }
        </td>
      </tr>
    }
    @if (task?.dueDate) {
      <tr>
        <td i18n="@@TaskCard_Tooltip_DueDate">Due Date:</td>
        <td>
          {{ task?.dueDate | date: "dd.MM.yyyy" }}
        </td>
      </tr>
    }
    @if (resources && task?.claimResourceID) {
      <tr>
        <td i18n="@@TaskCard_Tooltip_ClaimedBy">Is claimed by:</td>
        <td>{{ GetClaimedByName(task) }}</td>
      </tr>
    }
    @if (resources && task?.assignedToResourceID) {
      <tr>
        <td i18n="@@TaskCard_Tooltip_AssignedTo">Is assigned to:</td>
        <td>{{ GetAssignedToName(task) }}</td>
      </tr>
    }
  </table>
  @if (task?.description) {
    <hr
      style="background: rgba(255, 255, 255, 0.2); margin-top: 2px; margin-bottom: 2px;"
      />
  }
  @if (task?.description) {
    <div>
      {{ task?.description }}
    </div>
  }
  <hr
    style="background: rgba(255, 255, 255, 0.2); margin-top: 2px; margin-bottom: 2px;"
    />
    <div i18n="@@TaskCard_Tooltip_DoupleClick">
    Double-click on this card to open the task.
  </div>
  </div>
}
